import { fetchCreateCpdDraft } from 'shared/repositories/cpd/v1/create-cpd-draft';

import type { ICreateCPDDraftParams, TCreateCPDDraftResponse } from './types';
import { mappers } from './utils';

export const createCPDDraft = async (params: ICreateCPDDraftParams): Promise<TCreateCPDDraftResponse> => {
  const { httpApi, logger, parameters } = params;

  try {
    const response = await fetchCreateCpdDraft({ httpApi, parameters, mappers });

    return response as TCreateCPDDraftResponse;
  } catch (error) {
    logger.error(error, {
      description: 'Ошибка создания черновика CPD заявки /cpd/v1/create-cpd-draft/',
    });

    return {
      cpdDraftId: null,
      isSuccess: false,
    } as TCreateCPDDraftResponse;
  }
};
